import { render, staticRenderFns } from "./EditGameTypeForm.vue?vue&type=template&id=142d7f62&"
import script from "./EditGameTypeForm.vue?vue&type=script&lang=js&"
export * from "./EditGameTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports